module.exports = __webpack_public_path__ + "img/img_bgPM.cfab296c.png";